/* eslint-env jest */
import DataSet from './DataSet';

const inputDataset = {
    fields: [{ name: '_time' }, { name: '_raw' }, { name: 'foo2' }, { name: 'foo3' }, { name: 'foo4' }],
    columns: [
        [
            '2018-05-02T18:10:46.000-07:00',
            '2018-05-02T18:11:47.000-07:00',
            '2018-05-02T18:12:48.000-07:00',
            '2018-05-02T18:13:49.000-07:00',
            '2018-05-02T18:15:59.000-07:00',
        ],
        ['2', '10', '13', '60', '43'],
        ['1', '1', '1', '1', '1'],
        ['2', '30', '16', '10', '48'],
        ['2', '20', '0', null, '42'],
    ],
};

const originalData = new DataSet(inputDataset.fields, inputDataset.columns);

const truncatedData = {
    fields: [{ name: '_time' }, { name: '_raw' }, { name: 'foo2' }, { name: 'foo3' }, { name: 'foo4' }],
    columns: [
        ['2018-05-02T18:10:46.000-07:00', '2018-05-02T18:11:47.000-07:00'],
        ['2', '10'],
        ['1', '1'],
        ['2', '30'],
        ['2', '20'],
    ],
};

export const getOriginalDataSet = () => originalData;

export const getTruncatedDataSet = () => truncatedData;

/*
 * get expected base visualization props for unit test
 * @params {Object} dataSources
 * @returns {Object} props
 */
export const getBaseVisualizationProps = dataSources => ({
    dataSources,
    width: '100%',
    height: 250,
    mode: 'view',
    options: {},
    style: {},
    hasEventHandlers: false,
    onOptionsChange: expect.any(Function),
    onEventTrigger: expect.any(Function),
    onRequestParamsChange: expect.any(Function),
    visualizationApiRef: expect.any(Function),
    onSelected: expect.any(Function),
    onComputedProps: expect.any(Function),
});

/*
 * dataSources for choropleth visualization in unit test
 */
export const dataSourcesForChoroplethViz = {
    primary: {
        data: {
            fields: [
                {
                    name: 'country',
                },
                {
                    name: 'value',
                },
            ],
            columns: [
                ['United States', 'Russia', 'Australia', 'Brazil', 'Japan', 'China', 'India', 'Canada'],
                [17, 3, 65, 385, 69, 9, 142, 23],
            ],
        },
    },
};

/*
 * dataSources for time visualization in unit test
 */
export const dataSourcesForTimeViz = {
    primary: {
        requestParams: { offset: 0, count: 20 },
        data: {
            fields: [{ name: '_time', groupby_rank: '0' }, { name: 'count' }, { name: '_span' }],
            columns: [
                [
                    '2018-05-02T18:15:46.000-07:00',
                    '2018-05-02T18:15:47.000-07:00',
                    '2018-05-02T18:15:48.000-07:00',
                    '2018-05-02T18:15:49.000-07:00',
                    '2018-05-02T18:15:50.000-07:00',
                ],
                ['2', '10', '13', '60', '43'],
                ['1', '1', '1', '1', '1'],
            ],
        },
        meta: { totalCount: 20 },
    },
    annotation: {
        requestParams: { offset: 0, count: 20 },
        data: {
            fields: [
                { name: '_time', groupby_rank: '0' },
                { name: 'annotation_label' },
                { name: 'annotation_color' },
            ],
            columns: [
                [
                    '2018-05-02T18:11:50.000-07:00',
                    '2018-05-02T18:13:25.000-07:00',
                    '2018-05-02T18:14:30.000-07:00',
                ],
                ['houston, we have a problem', 'just close the jira', 'looking good now'],
                ['#f44271', '#f4a941', '#41f49a'],
            ],
        },
        meta: { totalCount: 20 },
    },
};

/*
 * dataSources for bubble, scatter, punchcard visualization in unit test
 */
export const dataSourcesForRelationViz = {
    primary: {
        requestParams: { offset: 0, count: 20 },
        data: {
            fields: [
                {
                    name: 'date_hour',
                },
                {
                    name: 'count',
                },
                {
                    name: 'mode(status)',
                },
                {
                    name: 'status',
                },
            ],
            columns: [
                ['13', '14', '15', '16', '17'],
                ['1109', '1108', '1098', '1088', '1097'],
                ['404', '200', '401', '201', '401'],
                ['401', '201', '401', '201', '401'],
            ],
        },
        meta: { totalCount: 20 },
    },
};

/*
 * dataSources for pie visualization in unit test
 */
export const dataSourcesForPieViz = {
    primary: {
        requestParams: { offset: 0, count: 20 },
        data: {
            fields: [{ name: 'component' }, { name: 'count' }],
            columns: [
                ['January', 'February', 'March', 'April', 'May'],
                ['1', '1', '1', '2', '10'],
            ],
        },
        meta: { totalCount: 20 },
    },
};

/*
 * dataSources for shape, gauge, and single value visualization in unit test
 */
export const dataSourcesWithNumAndColor = {
    primary: {
        data: {
            columns: [
                ['1', '62', '103', '308', '587', '876', '930', '1320'],
                ['#FF0000', '#00FFFF', '#0000FF', '#800080', '#FFFF00', '#FFA500', '#A52A2A', '#008000'],
                ['1320', '102', '103', '98', '587', '345', '123', '98'],
            ],
            fields: [
                {
                    name: 'count',
                },
                {
                    name: 'color',
                },
                {
                    name: 'number',
                },
            ],
        },
        meta: {},
    },
};
